export const environment = {
  production: false,

  aiApiKey: 'AIzaSyAXPVOsjm4N8_LIyNSWB7eBk0GDcI4Ru9c',
  aiApiUrl: 'https://api.openai.com/v1/chat/completions',

  apiVoucherUsername: 'ZVBPNPCHVMBUAQTZYOWPLTXVWXWYERDS',
  apiVoucherPassword: ']soLj$si!x6IL![KP~rkQ^sXG^hT3yJS',

  ai: {
    apiKey: 'AIzaSyAXPVOsjm4N8_LIyNSWB7eBk0GDcI4Ru9c',
    apiUrl: 'https://api.openai.com/v1/chat/completions'
  },

  voucherApi: {
    baseUrl: 'https://send.bulkgv.net',
    username: 'ZVBPNPCHVMBUAQTZYOWPLTXVWXWYERDS',
    password: ']soLj$si!x6IL![KP~rkQ^sXG^hT3yJS'
  },

  accountAggregator: {
    baseUrl: 'https://banxx-uat.moneyone.in',
    headers: {
      clientId: '3aa85e98f774f77b5c65818975d5e13e561d6a64',
      clientSecret: '0f832b6089579aeedfe7f532872ff0c3f833b424',
      organisationId: 'banxx-fiu-uat',
      appIdentifier: 'com.banxx.in'
    }
  },

  partnerApi: {
    baseUrl: 'https://loannet.in:8000/api',
    apiKey: '62c6298e-7bff-4aeb-a62f-f0a2f49b1a54'
  }
};